import type { Message } from './db'

export function formatConversationText(messages: Message[]): string {
  return messages
    .slice()
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((msg) => {
      const date = new Date(msg.timestamp)
      const time = date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
        + ' ' + date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
      const sender = msg.senderName || (msg.isOutgoing ? '(me)' : '(recipient)')
      const content = formatMessageContent(msg)
      return `[${time}] ${sender}: ${content}`
    })
    .join('\n')
}

function formatMessageContent(msg: Message): string {
  const parts: string[] = []
  if (msg.text) parts.push(msg.text)
  if (msg.attachments?.length) {
    for (const att of msg.attachments) {
      switch (att.type) {
        case 'image': parts.push('(image shared)'); break
        case 'file': parts.push(att.name ? `(file: ${att.name})` : '(file shared)'); break
        case 'audio': parts.push('(audio message)'); break
        case 'video': parts.push('(video shared)'); break
        case 'gif': parts.push('(GIF)'); break
        default: parts.push(`(${att.type} shared)`); break
      }
    }
  }
  return parts.join(' ') || '(empty message)'
}
